import { cn, convertCamelToServerError, insertObjectIf } from '@/utils';
import React, { memo } from 'react';

import { Input } from 'antd';
import { TextAreaProps } from 'antd/es/input';

import { Field, FieldProps } from 'formik';

export interface IFTextAreaInput extends TextAreaProps {
	name: string;
	formatInput?: (value: string, number?: number) => void;
	hasServerError?: boolean;
}

const FTextAreaInput: React.FC<IFTextAreaInput> = ({
	name,
	formatInput,
	hasServerError,
	className,
	...props
}) => {
	return (
		<Field name={name}>
			{({
				field, // { name, value, onChange, onBlur }
				form: { setValues }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
				meta,
			}: FieldProps) => {
				const _onChange = (
					e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
				) => {
					const serverErrorKey = convertCamelToServerError(String(name));

					setValues((prevValues: any) => ({
						...prevValues,
						[name]: formatInput
							? formatInput(e.target.value, props?.maxLength)
							: e.target.value,
						...insertObjectIf(Object.hasOwn(prevValues, serverErrorKey), {
							[serverErrorKey]: false,
						}),
						[serverErrorKey]: false,
					}));
				};

				return (
					<div className="flex-1">
						<Input.TextArea
							{...field}
							className={cn(
								'bg-white w-full text-[13px] text-font2 !min-h-[64px] xl:!min-h-[150px] rounded-none',
								className
							)}
							status={
								(meta.touched && meta.error) || hasServerError
									? 'error'
									: undefined
							}
							onChange={_onChange}
							{...props}
						/>
					</div>
				);
			}}
		</Field>
	);
};

export default memo(FTextAreaInput);
